// This is a collection of the various API calls required for directus

import axios from "axios";

let microContent;

async function getMicroContent() {
  const response = await axios.get(
    "//bhf-directus.wardourdigital.co.uk/say-no-to-food/items/micro_content?fields=title.*,micro_content.*,title_slug.*"
  );
  // console.log("MicroContentAPI", response.data.data);
  microContent = response.data.data;
}

export default async function() {
  if (!microContent) {
    await getMicroContent();
    return microContent;
  } else {
    return microContent;
  }
}
